module.exports = __webpack_public_path__ + "static/media/10_baskhs 1.9416c8f3.png";